import config from '@/common/config';

const FORMS_MESSAGE_SOURCE = 'yhrs-forms';
const FORMS_MESSAGE_VERSION = 1;

function trimTrailingSlash(value) {
	return (value || '').replace(/\/+$/, '');
}

export function getFormsAppBaseUrl() {
	return trimTrailingSlash(config.FORMS_APP_URL || 'http://localhost:3001');
}

export function getFormsAppOrigin() {
	return new URL(getFormsAppBaseUrl()).origin;
}

export function buildEmbeddedFormsUrl(path, query = {}) {
	const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '/';
	const url = new URL(`${getFormsAppBaseUrl()}${normalizedPath}`);
	const parentOrigin = window.location.origin;
	const params = {
		embedded: 'true',
		embedStyle: 'card',
		parentOrigin,
		...query
	};

	Object.keys(params).forEach(key => {
		if (params[key] === undefined || params[key] === null || params[key] === '') return;
		url.searchParams.set(key, params[key]);
	});

	return url.toString();
}

export function isTrustedFormsMessage(event, expectedOrigin = getFormsAppOrigin()) {
	if (!event || event.origin !== expectedOrigin) return false;
	const data = event.data;
	return !!data && data.source === FORMS_MESSAGE_SOURCE && data.version === FORMS_MESSAGE_VERSION;
}

export { FORMS_MESSAGE_SOURCE, FORMS_MESSAGE_VERSION };
